module.exports = __webpack_public_path__ + "static/img/14.207cf8b7.jpg";